
export const paths = []

export const CTERouters = {
    icon: "receipt",
    path: "/building-page...",
    label: "CT-e",
    tree: [
        {
            icon: "receipt",
            path: "/building-page...",
            label: "Emitir CT-e"
        }
    ]
}


// WEBPACK FOOTER //
// ./src/views/Fiscal/CTE/routers.js